import { HelpLink } from '@sokigo-sbwebb/default-components';
import { useLocation } from 'react-router-dom';

export function getSection(pathname: string) {
  switch (pathname) {
    case '/reflex/cases':
      return 'cases';
    case '/reflex/configs':
      return 'configs';
    case '/reflex/map':
      return 'map';
    case '/reflex/population':
      return 'population';
    case '/reflex/property':
      return 'property';
    case '/reflex/search':
      return 'search';
    case '/administration':
      return 'administration';
    case '/administration/configs':
      return 'configs';
    case '/administration/map':
      return 'map';
    case '/administration/system-settings':
      return 'system-settings';
    case '/administration/roles':
      return 'roles';
    default:
      return 'mainArticle';
  }
}

export function Help({ expanded }: { expanded: boolean }) {
  const { pathname } = useLocation();
  const section = getSection(pathname);

  return (
    <div className="d-flex align-items-center" style={{ width: !expanded ? 40 : '100%' }}>
      <HelpLink tooltipText="Hjälp" aria-label="Hjälp" section={section} block>
        {expanded && 'Hjälp'}
      </HelpLink>
    </div>
  );
}

export default Help;
